import React, { useState } from "react";
import {BrowserRouter as Router, Route, Routes, Navigate} from 'react-router-dom';
import Login from './components/login.js';
import { Menu } from "antd";
import TripTable from "./components/TripTable.js";
import PersData from "./components/PersData.js";
import dayjs from "dayjs";
function App(){
  const [user, setUser] = useState(null);
  const handleLogin = (username) => {
    setUser(username);
  };
   
  return (
    <Router>
      <div>
      <Routes>
        <Route exact path = "/" 
         element = {user ? <Navigate to = "/travelExpenses" /> : <Login onLogin={handleLogin}/>} />
        <Route path="/travelExpenses"
        element = {user ? <Men/> : <Navigate to = "/"/>}/>
        
        </Routes>
      </div>
    </Router>
  )};

  function Men(){
  const [personalData,setPersonalData]= useState({
      name:"",
      firstname:"",
      street: "",
      housenumber:"",
      postalCode: "",
      email:"",
      city: "",
      bank:"",
      iban:"",
      bic:"",
      vendor:""
    });
   const [confirmation, setConfirmation] = useState({
   name: "",
   date: dayjs(),
   confirmed: false,
 });   
 
 const [dataProtection, setDataProtection] = useState(
   false);
  
  const [schoolData, setSchoolData] = useState({
     city: "",
     name: "",
     postalCode: "",
     street: "",
     housenumber:"",
   });

const [visitedPlaces, setVisitedPlaces] = useState([]);


  const [monthlyTicketData, setMonthlyTicketData] = useState({
      active: false,
      validityPeriod: [],
      price: null
    });

  const [billingPeriod, setBillingPeriod] = useState([null,null]);

  const [currentMenu, setCurrentMenu] = useState("persData");
  const createEmptyExpandedRow = (key) => (
    {
   key,
   event: "",
   address: { type: "", name: "", street: "", housenumber: "", postalCode: "", city: "" },
   transportMode: "",
   segmentDistanceOpenRouteService: null,
   segmentDistance: null,
   ticketPrice: null,
   payBackTicketPrice: null,
   passenger: "",
   reason: "",
 });

   
   const createEmptyParentRow = (key) => ({
     key,
     timeRange: null,
     date: null,
     event: "",
     transport: "",
     perDiem: null,
     payback: null,
     expenses: [{ label: "", amount: null, receipt: null }],
     passengers:"",
    reasons:"",
     expandedData: [
       createEmptyExpandedRow(`${key}-1`),
       createEmptyExpandedRow(`${key}-2`)
     ]
   });
 
   const initialTripData = [
     createEmptyParentRow("1")    
   ];
   const [tripData, setTripData] = useState( initialTripData);
  return (
    <div>
      <Menu mode="horizontal" selectedKeys={[currentMenu]} onClick={(e) => setCurrentMenu(e.key)}>
        <Menu.Item key="persData">Formular</Menu.Item>
        <Menu.Item key="table">Tabelle</Menu.Item>
      </Menu>

      <div>{currentMenu === "persData" ? <PersData 
      personalData={personalData} 
      setPersonalData={setPersonalData}
      schoolData={schoolData}
      setSchoolData={setSchoolData}
      confirmation={confirmation}
      setConfirmation={setConfirmation} 
      dataProtection={dataProtection}
      setDataProtection={setDataProtection} 
      /> : <TripTable 
      personalData={personalData}
      setPersonalData={setPersonalData}
      schoolData={schoolData}
      setSchoolData={setSchoolData}
      visitedPlaces={visitedPlaces}
      setVisitedPlaces={setVisitedPlaces}
      tripData={tripData}
      setTripData={setTripData}
      monthlyTicketData={monthlyTicketData}
      setMonthlyTicketData={setMonthlyTicketData}
      confirmation={confirmation} 
      dataProtection={dataProtection}
      billingPeriod={billingPeriod}
      setBillingPeriod={setBillingPeriod}
       />}
       
      </div>
    </div>
  );
}

export default App;